'use client';

import { Image } from '@nextui-org/react';
import Link from 'next/link';
import { useEffect, useState } from 'react';

interface IProps {
  title: string;
}

export default function LinkShare(props: IProps) {

  //   const xLink = `https://twitter.com/share?url=${ encodeURIComponent(window.location.href)}&text=${encodeURIComponent(props.title)}`;
  // const fbLink = `http://www.facebook.com/sharer.php?u=${ encodeURIComponent(window.location.href) }&t=${encodeURIComponent(props.title)}`
  // let copyLink = () => {
  //   console.log(111111, navigator)
  //   if (navigator.share) {
  //     navigator.share({
  //       title: document.title,
  //       text: document.title,
  //       url: window.location.href
  //     })
  //   } else {

  //   }
  // }
  const [xLink, setXLink] = useState('');
  const [fbLink, setFbLink] = useState('');
  const [canShare, setCanShare] = useState(false);

  const handleShare = async () => {
    if (canShare) {
      navigator.share({
        title: document.title,
        text: document.title,
        url: window.location.href,
      });
    } else {
      // 降级处理
      navigator.clipboard?.writeText(window.location.href);
    }
  };

  useEffect(() => {
    setXLink(`https://twitter.com/share?url=${encodeURIComponent(window.location.href)}&text=${encodeURIComponent(props.title)}`);
    setFbLink(`http://www.facebook.com/sharer.php?u=${encodeURIComponent(window.location.href)}&t=${encodeURIComponent(props.title)}`);
    setCanShare(
      typeof navigator !== 'undefined' &&
      !!navigator.share &&
      (window.location.protocol === 'https:' ||
        window.location.hostname === 'localhost'));
  }, [props.title]);
  return (
    <>
      <div className="flex max-md:hidden">
        <Link href={xLink} target="_blank">
          <Image
            alt='x'
            src="/x.png"
            width={28}
            height={28}
            removeWrapper
          />
        </Link>
        <Link href={fbLink} target="_blank" className="pl-[10px]">
          <Image
            alt='facebook'
            src="/facebook.png"
            width={28}
            height={28}
            removeWrapper
          />
        </Link>
        <Image
          alt='share'
          src="/dot3.png"
          className="cursor-pointer"
          onClick={handleShare}
          width={28}
          height={28}
          classNames={{
            wrapper: 'ml-[10px]',
          }}
        />
      </div>

      {/* mobile */}
      <div className="hidden max-md:flex justify-center pt-1">
        <Link href={xLink} target="_blank">
          <Image
            alt='x'
            src="/x.png"
            width={28}
            height={28}
            removeWrapper
          />
        </Link>
        <Link href={fbLink} target="_blank" className="pl-[10px]">
          <Image
            alt='facebook'
            src="/facebook.png"
            width={28}
            height={28}
            removeWrapper
          />
        </Link>
        <Image
          alt='share'
          src="/dot3.png"
          className="cursor-pointer"
          onClick={handleShare}
          width={28}
          height={28}
          classNames={{
            wrapper: 'ml-[10px]',
          }}
        />
      </div>
    </>
  );
}
